import React, { useRef, useEffect, useState } from "react";
import EventHeader from "./EventHeader";
import { useNavigate } from "react-router-dom";
import "./events.css";
import { getEventsFetchData } from "../../../redux/actions/getEventAction";
import { useDispatch, useSelector } from "react-redux";
import { getBannerFetchData } from "../../../redux/actions/getBannerAction";
import { eventbaseurlforimages } from "../../../utils/httpService";

const BASE_URL =eventbaseurlforimages

const EventIndex = () => {

  const [currentIndex, setCurrentIndex] = useState(1); // Start at first real slide
  const [eventsData, setEventsData] = useState([]); // Start at first real slide
  // console.log("eventsData", eventsData);
  const [bannerImages, setBannerImages] = useState([]); // State for banner images
  const trackRef = useRef(null);
  const slideRefs = useRef([]);
  const dispatch = useDispatch();
  // Use an object to track expanded state per event
  const [expandedEvents, setExpandedEvents] = useState({});

  // Get banner data from Redux store
  const bannerData = useSelector((state) => state.getBannerReducer?.data);
  console.log("bannerData", bannerData?.banners);
  // console.log("bannerData", bannerData);
  useEffect(() => {
    dispatch(getEventsFetchData());
    dispatch(getBannerFetchData());
  }, []);
  // Update banner images when banner data changes
  useEffect(() => {
    if (bannerData) {
      if (bannerData?.banners) {
        const images = bannerData.banners.map(
          (banner) => `${BASE_URL}${banner.banner}`
        );
        setBannerImages(images);
      }
    }
  }, [bannerData]);
  // console.log("bannerImages", bannerImages);
  const slideCount = bannerImages.length;

  const updateSlider = (index, animated = true) => {
    const slideWidth = slideRefs.current[0]?.offsetWidth || 0;
    if (trackRef.current) {
      trackRef.current.style.transition = animated
        ? "transform 0.5s ease-in-out"
        : "none";
      trackRef.current.style.transform = `translateX(-${
        index * (slideWidth + 20)
      }px)`;
    }
  };

  // Get events data from Redux store
  const eventsDataa = useSelector((state) => state.getEventReducer?.data);

  useEffect(() => {
    setEventsData(eventsDataa?.events || []);
  }, [eventsDataa]);

  // Handle infinite loop
  useEffect(() => {
    if (currentIndex < 0) {
      setCurrentIndex(slideCount - 1);
    } else if (currentIndex >= slideCount) {
      setCurrentIndex(0);
    }
  }, [currentIndex, slideCount]);

  // Update slider on index change
  useEffect(() => {
    updateSlider(currentIndex, true);
  }, [currentIndex]);

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // On load, set initial position
  useEffect(() => {
    updateSlider(currentIndex, false);
    // eslint-disable-next-line
  }, []);

  const navigate = useNavigate();
  // Toggle expanded state for a specific event
  const toggleReadMore = (eventId) => {
    setExpandedEvents((prev) => ({
      ...prev,
      [eventId]: !prev[eventId],
    }));
  };

  // Utility to strip HTML tags
  function stripHtml(html) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  return (
    <div className="event-container">
      <EventHeader />
      <div
        className="carousel-container"
        style={{ overflow: "hidden", margin: "0 auto", }}
      >
        <div
          className="carousel-track"
          ref={trackRef}
          style={{
            display: "flex",
            transition: "transform 0.5s ease-in-out",
            cursor: "pointer",
          }}
        >
          {bannerData && bannerData?.banners && bannerData?.banners?.map((img, idx) => (
            <div
              onClick={() => navigate(`/event-detail/${img._id}`)}
              className={`carousel-slide${currentIndex === idx ? " active" : ""}`}
              key={idx}
              ref={(el) => (slideRefs.current[idx] = el)}
              style={{
                minWidth: "100%",
                margin: "0 10px",
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <img
                src={`${BASE_URL}${img.banner}`} 
                alt={`Event ${idx}`}
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  height: "450px",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <section className="container py-5 mb-5">
        {eventsData.length > 0 ? (
          <>
            <h2 className="text-center fw-bold mb-5">Upcoming Events</h2>
            <div className="row g-4">
              {eventsData.slice(0, 4).map((events, index) => (
                <div
                  className="col-md-3 col-sm-6"
                  key={events._id}
                  onClick={() => navigate(`/event-detail/${events._id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card h-100 shadow-sm">
                    <img
                      src={`${BASE_URL}${events.media[0]?.url}`}
                      className="card-img-top event-img-card-img"
                      alt={events.title}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{events.title}</h5>
                      {/* Show truncated or full description based on expanded state */}
                      <p className="card-text text-muted">
                        {expandedEvents[events._id]
                          ? <span dangerouslySetInnerHTML={{ __html: events.description }} />
                          : (
                              stripHtml(events.description).length > 100
                                ? stripHtml(events.description).slice(0, 100) + "..."
                                : stripHtml(events.description)
                            )
                        }
                      </p>
                      {/* Show Read More/Less only if description is long */}
                      {stripHtml(events.description).length > 100 && (
                        <span
                          onClick={e => {
                            e.stopPropagation(); // Prevent card click
                            toggleReadMore(events._id);
                          }}
                          style={{ color: "red", cursor: "pointer" }}
                        >
                          {expandedEvents[events._id] ? "Read Less" : "Read More"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-4">
              <a
                onClick={() => navigate("/all-events")}
                className="btn btn-primary px-4"
              >
                View All Events
              </a>
            </div>
          </>
        ) : (
          <div className="text-center fw-bold" style={{ fontSize: '1.5rem', padding: '3rem 0' }}>
            No events found
          </div>
        )}
      </section>
    </div>
  );
};

export default EventIndex;
